const PlusOutline = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='40'
    height='40'
    viewBox='0 0 40 40'
  >
    <path
      fill='#000'
      fillRule='nonzero'
      d='M20.75 19.25h8.5a.75.75 0 1 1 0 1.5h-8.5v8.5a.75.75 0 1 1-1.5 0v-8.5h-8.5a.75.75 0 1 1 0-1.5h8.5v-8.5a.75.75 0 1 1 1.5 0v8.5zM20 36.5c9.113 0 16.5-7.387 16.5-16.5S29.113 3.5 20 3.5 3.5 10.887 3.5 20 10.887 36.5 20 36.5zm0 1.5c-9.941 0-18-8.059-18-18S10.059 2 20 2s18 8.059 18 18-8.059 18-18 18z'
    />
  </svg>
);

export default PlusOutline;
